import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { BreadcrumbJsonLd } from 'next-seo';
import {WEBSITE_URL} from "@/content";
import {ItemListElements} from "next-seo/lib/types";

interface BreadCrumbProps {
    title: string;
    categoryTitle: string;
    categoryRoute: string;
    headCategoryTitle: string;
    headCategoryRoute: string;
    slug: string;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({
                                                   title,
                                                   categoryTitle,
                                                   categoryRoute,
                                                   headCategoryTitle,
                                                   headCategoryRoute,
                                                    slug
                                               }) => {

    const itemListElements: ItemListElements[] = [
        {
            position: 1,
            name: 'Home',
            item: `${WEBSITE_URL}`,
        },
        {
            position: 2,
            name: categoryTitle,
            item: `${WEBSITE_URL}/${categoryRoute}`,
        },
        {
            position: 3,
            name: headCategoryTitle,
            item: `${WEBSITE_URL}/${categoryRoute}/${headCategoryRoute}`,
        },
        {
            position: 4,
            name: title,
            item: `${WEBSITE_URL}/${categoryRoute}/${headCategoryRoute}/${slug}`,
        },
    ];




    return (
        <>
            <BreadcrumbJsonLd
                itemListElements={itemListElements}
                type="BreadcrumbList" />

            <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                    padding: {xs: '10px', lg: '10px'},
                    boxSizing: 'border-box',
                }}
            >
                <Link underline="hover" color="inherit" href="/">
                    Home
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    href={`/${categoryRoute}`}
                >
                    {categoryTitle}
                </Link>
                {headCategoryTitle && (
                    <Link
                        underline="hover"
                        color="inherit"
                        href={`/${headCategoryRoute}`}
                    >
                        {headCategoryTitle}
                    </Link>
                )}
                <Typography sx={{color: 'text.primary', padding: {xs: '0', lg: '0'}}}>
                    {title}
                </Typography>
            </Breadcrumbs>

        </>

    );
};

export default BreadCrumb;
